import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { PLATFORMS } from "@/lib/platforms";
import { Compass } from "lucide-react";

export default function Sidebar() {
  const location = useLocation();

  return (
    <aside className="hidden md:flex fixed left-0 top-0 bottom-0 w-20 z-40 sidebar-glass flex-col items-center" data-testid="sidebar">
      <div className="pt-6 pb-6">
        <Link to="/" className="block" data-testid="sidebar-logotype" title="Novcovek">
          <span className="relative w-10 h-10 rounded-2xl overflow-hidden flex items-center justify-center" style={{ background: "linear-gradient(135deg, #4CAF7D, #6B74DC 70%, #8B72EC)" }}>
            <span className="w-3.5 h-3.5 rounded-full bg-white/90 morph" />
          </span>
        </Link>
      </div>
      <nav className="flex-1 flex flex-col items-center gap-2 overflow-y-auto pb-4 pt-1">
        {PLATFORMS.map((p, i) => {
          const active = location.pathname.startsWith(p.path);
          const Icon = p.icon;
          return (
            <motion.div key={p.key} initial={{ opacity: 0, x: -14 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.05 * i, duration: 0.4, ease: [0.22, 1, 0.36, 1] }} className="rail-item relative">
              <Link
                to={p.path}
                aria-label={p.name}
                className="side-item flex w-11 h-11 rounded-2xl items-center justify-center"
                style={{
                  background: active ? p.hue : p.soft,
                  color: active ? "#fff" : p.deep,
                  boxShadow: active ? `0 8px 20px ${p.hue}55` : "none",
                }}
                data-testid={`sidebar-platform-${p.key}`}
              >
                <Icon size={18} />
              </Link>
              <span className="rail-tip glass-strong rounded-xl px-3 py-1.5 text-xs font-semibold" style={{ color: p.deep }}>
                {p.name}
              </span>
              {active && <span className="absolute -left-[18px] top-1/2 -translate-y-1/2 w-1.5 h-6 rounded-full" style={{ background: p.hue }} />}
            </motion.div>
          );
        })}
      </nav>
      <div className="pb-5">
        <div className="rail-item relative">
          <button
            onClick={() => window.dispatchEvent(new CustomEvent("nc-open-compass"))}
            className="side-item glass w-11 h-11 rounded-2xl flex items-center justify-center"
            aria-label="Take a bearing"
            data-testid="sidebar-compass-btn"
          >
            <Compass size={18} style={{ color: "#5D48C0" }} />
          </button>
          <span className="rail-tip glass-strong rounded-xl px-3 py-1.5 text-xs font-semibold">Take a bearing</span>
        </div>
      </div>
    </aside>
  );
}
